<template lang="html">
  <div id="inquire-floorplan" v-if="plan !== null">
    <i class="ion-close-round" data-pack="default" data-tags="delete, trash, kill, x" @click="closeInquire()"></i>
    <div class="content" v-if="!sent">
      <div class="plans">
        <div class="details">
          <div class="title" v-html="plan.name">
          </div>
          <h1 class="mobile_title">
            inquire about <span v-html="plan.name"></span>
          </h1>

          <div class="type">
            {{ getType(plan) }}
          </div>
          <!-- <div class="baths"> -->
          <!-- 1 Bathroom -->
          <!-- </div> -->
          <div class="size">
            {{ plan.conditions[0].interior }} Square Feet
          </div>
        </div>
        <div class="img" :style="{'background-image': 'url(' + baseUrl + getImage('fp', plan) + ')'}">
        </div>
        <div class="clear">
        </div>
      </div>

      <!-- Email Input -->
      <div class="email">
        <input class="inquire" :class="{'error': this.status.error}" id="name" v-model="postParams.name" placeholder=" " />
        <label class="float-label" for="name">enter your name</label>
      </div>

      <div class="email">
        <input class="inquire" :class="{'error': this.status.error}" id="email" v-model="postParams.email" placeholder=" " />
        <label class="float-label" for="email">enter your email address</label>
      </div>
      <transition name="fade">
        <div class="status" v-show="this.status.message" :class="{'error': this.status.error}">
          {{ this.status.message }}
        </div>
      </transition>

      <div class="email">
        <input class="inquire" :class="{'error': this.status.error}" id="phone" v-model="postParams.phone" placeholder=" " />
        <label class="float-label" for="phone">enter your phone number</label>
      </div>

      <div class="email">
        <textarea class="inquire" :class="{'error': this.status.message_error}" id="message" v-model="postParams.emailMessage" placeholder=" " rows="4">
        </textarea >
        <label class="float-label" for="message">enter your message</label>
      </div>

      <div class="checkbox_row">
        <!-- <input type="checkbox" id="optin" v-model="postParams.optin"/>
        <label for="optin"><span>I agree to receive communications from Livmore regarding Suite Leasing</span></label> -->
        <ul class="checkboxes">
          <li>
            <div
              class="mobile-check inquire"
              role="checkbox"
              aria-checked="false"
              tabindex="0"
              id="mobile_opt-in"
              @click="toggleInput()"
            >
              I agree to receive communications from Livmore regarding Suite Leasing
            </div>
          </li>
        </ul>
      </div>
      <transition name="fade">
        <div class="status" v-show="this.status.optin" :class="{'error': this.status.error}">
          {{ this.status.optin }}
        </div>
      </transition>

      <transition name="fade" mode="out-in">
        <button class='send-btn' v-if="!sending" @click="sendEmail()">send message</button>
        <!-- <div class='send-btn' v-if="!sending">send message</div> -->
        <span v-else-if="sending && !status.message" class="ion-load-c"></span>
      </transition>

      <button class="send-btn mobile" @click="closeInquire()">
        close
      </button>
    </div>
    <div class="content" v-if="sent">
      <div class="thank_you">
        Thank you!<br /><br />
        We've received your message and someone will be in contact with you as soon as possible.
      </div>
      <div class="send-btn mobile" @click="closeInquire()">
        close
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
/* eslint indent: 0 */

import Vue from 'vue';
import EventBus from '../EventBus';

export default {
  name: 'app-inquire-floorplan',
  props: ['plan', 'filters'],
  data() {
    return {
      baseUrl:
        'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
      postParams: {
        fp_name: '',
        name: '',
        email: '',
        phone: '',
        emailMessage: '',
        filters: '',
        // unchanged
        email_title:
          'The Livmore - Refined Residential Rentals - Floorplans Inquiry',
        sender: 'do_not_reply@adhocstudio.ca',
        sender_name: 'The Livmore Webapp',
        contact: 'The Livmore',
        bcc: ['leon@adhocstudio.ca'],
        optin: false
      },
      sending: false,
      status: {
        error: false,
        message: '',
        message_error: ''
      },
      sent: false,
      cb: false
    };
  },
  methods: {
    reinit() {
      this.postParams.name = '';
      this.postParams.email = '';
      this.postParams.phone = '';
      this.postParams.emailMessage = '';
      this.postParams.filters = '';
      this.postParams.optin = false;
      this.sending = false;
      this.sent = false;

      this.status.error = true;
      this.status.message = '';
      this.status.optin = '';

      // this.calcVH();
      // mobile checkbox init, has to be called separately from App.vue
      this.tryInitCB();
    },
    calcVH() {
      // const vH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 75;
      // document.getElementById('floorplans').setAttribute('style', 'height:' + vH + 'px;');
    },
    getType(plan) {
      switch (plan.type) {
        case 'one': {
          return '1 Bedroom';
        }
        case 'oneDen': {
          return '1 Bedroom + Den';
        }
        case 'two': {
          return '2 Bedroom';
        }
        case 'twoDen': {
          return '2 Bedroom + Den';
        }
        case 'three': {
          return '3 Bedroom';
        }
        case 'threeDen': {
          return '3 Bedroom + Den';
        }
        default: {
          return 'Studio';
        }
      }
    },
    getImage(type, plan) {
      return plan.conditions[0].images.find(img => img.type === type).url;
    },
    closeInquire() {
      this.postParams.email = '';
      this.status.error = false;
      this.status.message = '';
      console.log('closeInquire');
      EventBus.$emit('closeInquire');
    },
    goHome() {
      this.closeInquire();
      EventBus.$emit('openMenu');
    },
    generateFilters() {
      this.postParams.filters = '';
      const types = this.filters.types
        .filter(type => type.active)
        .map(type => type.name);
      const levels = this.filters.levels
        .filter(level => level.active)
        .map(level => level.name);
      const dirs = this.filters.directions
        .filter(dir => dir.active)
        .map(dir => dir.name);

      this.postParams.filters += 'Types Selected: ';
      if (types.length === 0) {
        for (let i = 0; i < this.filters.types.length; i += 1) {
          this.postParams.filters += `${this.filters.types[i].name}`;
          if (i !== this.filters.types.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      } else {
        for (let j = 0; j < types.length; j += 1) {
          this.postParams.filters += `${types[j]}`;
          if (j !== types.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      }

      this.postParams.filters += '<br/>Levels Selected: ';
      if (types.length === 0) {
        for (let k = 0; k < this.filters.levels.length; k += 1) {
          this.postParams.filters += `${this.filters.levels[k].name}`;
          if (k !== this.filters.levels.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      } else {
        for (let l = 0; l < levels.length; l += 1) {
          this.postParams.filters += `${levels[l]}`;
          if (l !== levels.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      }

      this.postParams.filters += '<br/>Directions Selected: ';
      if (types.length === 0) {
        for (let m = 0; m < this.filters.directions.length; m += 1) {
          this.postParams.filters += `${this.filters.directions[m].name}`;
          if (m !== this.filters.directions.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      } else {
        for (let n = 0; n < dirs.length; n += 1) {
          this.postParams.filters += `${dirs[n]}`;
          if (n !== dirs.length - 1) {
            this.postParams.filters += ', ';
          }
        }
      }
    },
    sendEmail() {
      this.status.message = '';
      if (!this.validEmail(this.postParams.email)) {
        this.status.error = true;
        this.status.message = 'Please enter a valid email address';
        return;
      }

      if (!this.postParams.optin) {
        this.status.error = true;
        this.status.optin = 'Please agree to receive communications';
        return;
      }

      this.postParams.fp_name = this.plan.name;
      this.generateFilters();

      this.sending = true;
      const emailPostUrl =
        'https://adhocstudio.ca/dev/email/Livmore_Inquire.php';
      $.post(emailPostUrl, this.postParams)
        .then(res => {
          const _ = this;
          this.status.error = false;
          this.status.message = '';
          this.sent = true;
          setTimeout(() => {
            _.closeInquire();
            _.sending = false;
            _.status.message = '';
            _.status.error = false;
          }, 5000);
        })
        .catch(e => {
          console.log(e);
          this.sending = false;
          this.status.error = true;
          this.status.message =
            'There was a problem connecting to the server. Please try again later.';
        });
    },
    validEmail(email) {
      /* eslint no-useless-escape: 0 */
      /* eslint max-len: 0 */
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email);
    },
    toggleInput() {
      const id = 'mobile_opt-in';
      const el = document.getElementById(id);
      if (el.getAttribute('aria-checked') === 'true') {
        // console.log('aria-checked going to be false now');
        this.postParams.optin = false;
      } else {
        // console.log('aria-checked going to be true now');
        this.postParams.optin = true;
      }
    },
    tryInitCB() {
      if (!this.cb) {
        try {
          // setTimeout(() => {
          var thisPage = document.getElementById('inquire-floorplan');
          var checkboxes = thisPage.querySelectorAll('[role="checkbox"]');
          console.log(checkboxes);
          for (var i = 0; i < checkboxes.length; i++) {
            var cb = new Checkbox(checkboxes[i]);
            cb.init();
          }
          this.cb = true;
          // }, 1500);
        } catch (e) {
          this.cb = false;
          setTimeout(() => {
            this.tryInitCB();
          }, 1500);
        }
      }
    }
  },
  mounted() {
    setTimeout(
      () => {
        this.reinit();
      },
      200,
      this
    );

    // this.calcVH();
    // window.addEventListener('onorientationchange', this.calcVH, true);
    // window.addEventListener('resize', this.calcVH, true);
  },
  created() {
    EventBus.$on('inquireFloorplanOpen', this.reinit);
  }
};
</script>

<style lang="scss" scoped>
@import './../globals.scss';

#inquire-floorplan {
  z-index: 22;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3D(-50%, -50%, 0);
  display: none;

  max-width: 800px;
  min-width: 40%;

  background-color: $livmoreBeige;
  // padding: 20px;

  -webkit-box-shadow: -5px 10px 29px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -5px 10px 29px -5px rgba(0, 0, 0, 0.75);
  box-shadow: -5px 10px 29px -5px rgba(0, 0, 0, 0.75);

  border: 1px solid #cac1ae;
  padding: 20px;

  transition: all 0.5s ease-out;
  opacity: 0;
  pointer-events: none;

  i.ion-close-round {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 20px;
    color: $livmoreRed;
    font-size: 1.5rem;

    cursor: pointer;
    transition: all 0.5 ease-out;

    &:active,
    &:hover {
      transform: scale(0.95);
    }
  }

  .content {
    margin: 4rem 8rem;

    .plans {
      margin-bottom: 3rem;
      padding-top: 2rem;

      .details {
        text-align: left;
        display: inline-block;
        float: left;

        .title {
          font-size: 1.8rem;
          // color: $livmoreRed;
          color: $livmoreBlack;
          margin-bottom: 1.25rem;
        }

        .mobile_title {
          display: none;
          text-align: center;
          // color: $livmoreRed;
          color: $livmoreBlack;
          font-family: $chronicleDeck;
          font-weight: $chronicleDeck-Semi;
          font-size: 16px;
          letter-spacing: 1px;
          margin: 0;
        }

        .type,
        .bath,
        .size,
        .direction {
          line-height: 2;
        }
      }

      .img {
        display: inline-block;
        float: right;
        width: 170px;
        height: 170px;

        background-color: $livmoreBeige;
        background-blend-mode: multiply;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }

    .email {
      margin-bottom: 20px;
      text-align: left;

      .inquire {
        border: 2px solid $livmoreRed;
        background-color: $livmoreBeige;
        padding: 5px;

        width: 100%;
        max-width: 480px;

        font-size: 1.13rem;
        font-family: $lato;

        &:-webkit-input-placeholder {
          color: #404041;
        }
      }
    }

    .status {
      margin-top: -15px;
      margin-bottom: 10px;
    }

    .checkbox_row {
      margin-bottom: 20px;
      text-align: left !important;
      -webkit-tap-highlight-color: transparent;

      .optin {
        span {
          display: inline-block;
        }
      }
    }

    .send-btn {
      display: block;
      width: 100%;
      border: none;

      // background-color: $livmoreRed;
      background-color: $livmoreBlack;
      color: $livmoreBeige;
      font-family: $chronicleDeck;
      padding: 10px;
      letter-spacing: 1px;
      margin-bottom: 10px;

      cursor: pointer;
      user-select: none;
      -webkit-tap-highlight-color: transparent;

      transition: all 0.5 ease-out;

      &:active,
      &:hover {
        transform: scale(0.99);
      }

      &.mobile {
        display: none;
      }
    }

    .thank_you {
      text-align: center;
    }
  }

  &.active {
    opacity: 1;
    pointer-events: all;
    display: block;
  }

  .mobile-check {
    &.inquire {
      text-transform: initial;
    }
  }
  // input[type="checkbox"] {
  //   background: $livmoreBeige;
  //   border-color: $livmoreBeige;
  // }

  // input[type="checkbox"] + label {
  //   display: inline-block;
  //   max-width: 80%;
  // }

  /* Custom checkbox */
  // [type="checkbox"]:not(:checked),
  // [type="checkbox"]:checked {
  //   position: absolute;
  //   left: -9999px;
  // }
  // [type="checkbox"]:not(:checked) + label,
  // [type="checkbox"]:checked + label {
  //   position: relative;
  //   padding-left: 2.5em;
  //   padding-top: 2px;
  //   cursor: pointer;
  //   user-select: none;
  //   // text-transform: uppercase;
  //   color: $livmoreBlack;
  //   display: inline-block;
  // }

  // /* checkbox aspect */
  // [type="checkbox"]:not(:checked) + label:before,
  // [type="checkbox"]:checked + label:before {
  //   content: '';
  //   position: absolute;
  //   left: 0; top: 0;
  //   width: 1.25em; height: 1.25em;
  //   border: 1px solid $livmoreRed;
  //   background: transparent;
  //   border-radius: 0px;
  // }
  // /* checked mark aspect */
  // [type="checkbox"]:not(:checked) + label:after,
  // [type="checkbox"]:checked + label:after {
  //   content: '';
  //   position: absolute;
  //   background-color: $livmoreRed;
  //   height: 0.95em;
  //   width: 0.95em;
  //   top: 0; left: 0;
  //   font-size: 1.4em;
  //   line-height: 0.8;
  //   color: #09ad7e;
  //   transition: all .2s;
  // }
  // /* checked mark aspect changes */
  // [type="checkbox"]:not(:checked) + label:after {
  //   opacity: 0;
  //   transform: scale(0);
  // }
  // [type="checkbox"]:checked + label:after {
  //   opacity: 1;
  //   transform: scale(1);
  // }
  // /* disabled checkbox */
  // [type="checkbox"]:disabled:not(:checked) + label:before,
  // [type="checkbox"]:disabled:checked + label:before {
  //   box-shadow: none;
  //   border-color: #bbb;
  //   background-color: #ddd;
  // }
  // [type="checkbox"]:disabled:checked + label:after {
  //   color: #999;
  // }
  // [type="checkbox"]:disabled + label {
  //   color: #aaa;
  // }
  // [type="checkbox"]:focus {
  //   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
  // }
}

@media screen and (max-width: 1440px) {
  #inquire-floorplan {
    max-width: 800px;
    // min-width: 55%;
    .content {
      margin: 1rem 4rem;
    }
  }
}

@media screen and (max-width: 1280px) {
  #inquire-floorplan {
    max-width: none;
    min-width: 45%;
    .content {
      margin: 1rem 4rem;
    }
  }
}

@media screen and (max-width: 1024px) {
  #inquire-floorplan {
    max-width: none;
    min-width: 70%;
    .content {
      margin: 1rem 4rem;
    }
  }
}

@media screen and (max-width: 768px) {
  #inquire-floorplan {
    max-width: none;
    min-width: 70%;
    .content {
      margin: 1rem 4rem;
    }
  }
}

@media screen and (max-width: 767px) {
  #inquire-floorplan {
    width: 100vw;
    // height: calc(100vh - 75px);
    height: calc(100vh);
    top: 0;
    left: 0;
    transform: translate3D(0, 0, 0);
    padding: 0;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    border: 0px;

    i.ion-close-round {
      display: none;
    }
    .content {
      margin: 1rem 3rem;
      // width100%

      .plans {
        margin-bottom: 1.25rem;
        padding-top: 1rem;

        .details {
          text-align: center;
          display: block;
          float: none;

          .title {
            display: none;
          }

          .mobile_title {
            display: block;
          }

          .type,
          .bath,
          .size,
          .direction {
            display: none;
          }
        }

        .img {
          display: none;
        }
      }

      .checkbox_row {
        font-size: 14px;

        span {
          display: inline-block;
          vertical-align: top;
          transform: translate3D(0, -5px, 0);
        }
      }

      .email {
        position: relative;

        input.inquire {
          font-size: 15px;
        }

        label.float-label {
          left: 0.5em;
          opacity: 1;
          position: absolute;
          top: 0.25em;
          transition: all 0.1s linear;
        }

        input:focus + label {
          // color: #2ea8c5;
          font-size: 1.15em;
          // left: .75em;
          opacity: 1;
          top: -1.25em;
        }

        textarea.inquire {
          height: 3em;
          font-size: 15px;
        }

        textarea:focus + label {
          // color: #2ea8c5;
          font-size: 1.15em;
          // left: .75em;
          opacity: 1;
          top: -1.25em;
        }

        input:not(:placeholder-shown) + label {
          top: -1.25em;
        }

        textarea:not(:placeholder-shown) + label {
          top: -1.25em;
        }
      }

      .send-btn {
        &.mobile {
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InquireFloorplan.vue